var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.48206 9.89795C3.9303 9.89795 3.48206 9.44951 3.48206 8.89837C3.48206 8.34722 3.9303 7.89795 4.48206 7.89795C5.03381 7.89795 5.48206 8.34722 5.48206 8.89837C5.48206 9.44951 5.03381 9.89795 4.48206 9.89795Z",
    fill: "#8F94A4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48206 9.89795C7.9303 9.89795 7.48206 9.44951 7.48206 8.89837C7.48206 8.34722 7.9303 7.89795 8.48206 7.89795C9.03381 7.89795 9.48205 8.34722 9.48205 8.89837C9.48205 9.44951 9.03381 9.89795 8.48206 9.89795Z",
    fill: "#8F94A4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4821 9.89795C11.9303 9.89795 11.4821 9.44951 11.4821 8.89837C11.4821 8.34722 11.9303 7.89795 12.4821 7.89795C13.0338 7.89795 13.4821 8.34722 13.4821 8.89837C13.4821 9.44951 13.0338 9.89795 12.4821 9.89795Z",
    fill: "#8F94A4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.3333,
    height: 2.33333,
    fill: "white",
    transform: "translate(3.26691 7.69629)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDots);
export default __webpack_public_path__ + "static/media/icon-three-dots.c9abd3cedbb368656fd8ed3616ba0882.svg";
export { ForwardRef as ReactComponent };